<template>
  <my-giving-layout :enable-scroll-event="true">
    <div class="bg-[#F6F4F0]">
      <BackButton class="w-full px-[20px] md:px-[24px] lg:px-[28px] mb-[16px]" :customBack="back" />
      <h1
        class="font-bold text-[1.5rem] md:text-[2rem] lg:text-[2.25rem] leading-[2rem] md:leading-[2.5rem] lg:leading-[2.75rem] ml-[28px] md:ml-[32px] lg:ml-[36px] mb-[26px]"
      >
        Types of Funds
      </h1>
      <div class="pb-[165px]">
        <div class="px-[20px] md:px-[24px] lg:px-[28px] h-full">
          <FilterAccordian
            :title="GFData.title"
            :description="GFData.description"
            :isGeneralFund="true"
            additionalCollapseClass="mb-[16px]"
          />
          <FilterAccordian
            :title="HCSData.title"
            :description="HCSData.description"
            additionalCollapseClass="mb-[16px]"
          />
          <FilterAccordian
            :title="MissionData.title"
            :description="MissionData.description"
            additionalCollapseClass="mb-[16px]"
          />
          <FilterAccordian
            :title="BFData.title"
            :description="BFData.description"
            additionalCollapseClass="mb-[16px]"
          />
          <FilterAccordian :title="GensData.title" :description="GensData.description" />
        </div>
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import FilterAccordian from '@/components/MyGiving/Common/FilterAccordian.vue';
import BackButton from '@/components/common/BackButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';

export default {
  components: { FilterAccordian, BackButton, MyGivingLayout },
  data() {
    return {
      GFData: {
        title: 'General Fund (Tithes and Offerings)',
        description:
          'Your giving helps Heart of God Church’s operational needs, which includes running in-person services.',
      },
      HCSData: {
        title: 'Heart Community Services',
        description: `Heart Community Services (HCS) provides financial, 
        education and social services to our local community.<br/><br/>
        Through HCS, pocket money, opportunity grants and scholarships are disbursed to young people from less well-to-do backgrounds, 
        or whose families are going through a financial crisis.`,
      },
      MissionData: {
        title: 'Missions',
        description: `Our Missions Fund supports the local and overseas mission work of Heart of God Church.
        We strategically partner with organisations to support and facilitate projects with lasting impact.
        These include providing humanitarian assistance and aid to disaster relief work.`,
      },
      BFData: {
        title: 'Building Fund',
        description: `As HOGC does not have premises of its own, the Building, Equipment and Rental Fund is necessary to cover the rental, maintenance and renovation expenses of its current premises, as well as expenses to secure future premises. The Building Fund is funded by HOGC members through a voluntary pledge fulfilment. <br/><br>
          Note: Youths who are 16 years old and below and/or in secondary school may not give
          an amount exceeding $200 a month for BF unless they obtain parental consent.`,
      },
      GensData: {
        title: 'GenerationS Fund',
        description: `To find out more, head to<br/>
        <a href="#" onclick="window.open('https://GenerationSmvmt.com', '_system', 'location=yes'); return false;"
        class="underline">GenerationSmvmt.com</a>`,
      },
    };
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace('/my-giving');
      }
    },
  },
};
</script>
